// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tZ2qNFSj59HTuroKn6yi{--wds-text-button-label-color: var(--fandom-global-nav-mobile-community-sticky-bar-color) !important;--wds-text-button-label-color--hover: var(--fandom-global-nav-mobile-community-sticky-bar-color) !important;padding:7px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `tZ2qNFSj59HTuroKn6yi`
};
export default ___CSS_LOADER_EXPORT___;
